import React from 'react';

import {
  AccordionItem,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../../components';

import './style.scss';

const FAQAccordionItem = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'value']);
  const linkHref = entity.getIn(['field_link_to_page', 0, 'alias'], entity.getIn(['field_link_to_page', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link_to_page', 0, 'title']);

  const renderItemContent = () => {
    return (
      <div className="FAQAccordionItem__content">
        <div className="col-12 col-lg-9 FAQAccordionItem__content__inner">
          <WysiwygField
            property="schema:text"
            className="Text__body"
            html={body}
          />
          {linkHref && linkTitle && (
            <Button className="ParagraphText__button" inverted href={linkHref}>{linkTitle}</Button>
          )}
        </div>
      </div>
    );
  };

  return (
    <AccordionItem
      className="FAQAccordionItem"
      title={title}
      content={renderItemContent()}
      titleComponent={({ className, children }) => {
        return (<h3 className={className}>{children}<i className="icon icon-caret" /></h3>);
      }}
    />
  );
};

export default FAQAccordionItem;
